import {Theme} from '@/entities/Theme';

export class ThemeTree {

  private readonly _root: ThemeTreeNode

  constructor(root: ThemeTreeNode) {
    this._root = root;
  }


  get root(): ThemeTreeNode {
    return this._root;
  }
}


export class ThemeTreeNode {

  private _children: ThemeTreeNode[];
  private readonly _theme: Theme;
  private readonly _parentId: string

  constructor(theme: Theme, children: ThemeTreeNode[],parentId: string) {
    this._children = children;
    this._theme = theme;
    this._parentId = parentId;
  }


  get parentId(): string {
    return this._parentId;
  }

  get children(): ThemeTreeNode[] {
    return this._children;
  }

  set children(value: ThemeTreeNode[]) {
    this._children = value;
  }

  get theme(): Theme {
    return this._theme;
  }
}
